import { Link, useNavigate } from "react-router-dom";
import { isOwner, getUserFromToken } from "../utils/auth";

function NavBar() {
  const navigate = useNavigate();
  const user = getUserFromToken();

  const isTerminalLocked = localStorage.getItem("terminalLocked");

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.brand}>
        <strong>MJ UNIQUE VENTURES LTD</strong>
        
      </div>

      <div style={styles.links}>
        {/* Staff and owner can access checkout */}
        <Link to="/" style={styles.link}>
          Checkout
        </Link>

        {/* Owner-only navigation */}
        {isOwner() && (
          <>
            <Link to="/dashboard" style={styles.link}>
              Dashboard
            </Link>

            <Link to="/products" style={styles.link}>
              Products
            </Link>

            <Link to="/sales-history" style={styles.link}>
              Sales History
            </Link>

            <Link to="/staff" style={styles.link}>
              Staff
            </Link>

            <Link to="/shop-settings" style={styles.link}>
              Shop
            </Link>

            <Link to="/account-settings" style={styles.link}>
              Account
            </Link>

          </>
        )}

        <button onClick={logout} style={styles.logoutButton}>
          Logout
        </button>
      </div>
    </nav>
  );
}

export default NavBar;

const styles = {
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
    background: "#111827",
    color: "white",
  },

  brand: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "18px",
  },

  role: {
    fontSize: "12px",
    opacity: 0.7,
  },

  links: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },

  link: {
    color: "white",
    textDecoration: "none",
    fontSize: "14px",
  },

  linkButton: {
    background: "transparent",
    border: "none",
    color: "white",
    cursor: "pointer",
    fontSize: "14px",
  },

  logoutButton: {
    padding: "8px 12px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    background: "#ff4d4f",
    color: "white",
  },
};